import { MenuItem, TextField } from '@mui/material';
import { FilterProps } from 'react-table';
import { useFilterOptions } from 'shared/queries';
import { Product } from 'shared/types';

export default function SelectFilter({ column: { filterValue, setFilter, render, id } }: FilterProps<Product>) {
    const { options, isLoading } = useFilterOptions(id);
    return (
        <TextField
            select
            label={render('Header')}
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined);
            }}
        >
            {(isLoading ? ['Loading...'] : options || []).map((option, i) => (
                <MenuItem key={i} value={option}>
                    {option}
                </MenuItem>
            ))}
        </TextField>
    );
}
